import React from 'react';
import { Helmet } from 'react-helmet';
import AppLayoutTitle from './appLayoutTitle';
import { apiGet } from '../../helper/helperApi';
import { handleException } from '../../helper/helperError';
import ComLoading from '../components/comLoading';


const AppProfile = () => {
    const [dataset, setDataset] = React.useState(undefined);

    React.useEffect(() => {
        apiGet('/auth/profile')
            .then((res) => { setDataset(res.data); })
            .catch((ex) => handleException(ex, "Failed to fetch profile data"));
    }, []);

    return <>
        <Helmet>
            <title>Profile | Sparkling Email</title>
        </Helmet>
        <>
            <AppLayoutTitle title="Your Account Profile" />
            <div className="px-3 py-3">
                <div>
                    Here you can view your personal information.<br />
                    Your core profile details are synchronized and managed directly by the external provider you use to sign in.
                </div>
                <div>
                    To update your name, please make changes directly within your Google, Microsoft,
                    or Yahoo account settings, then sign in again to reflect the changes here. For
                    any questions or assistance, feel free to reach out to our team at <a
                        className="text-decoration-none text-dark fw-semibold"
                        href="mailto:support@sparklingemail.com"
                        title="Support Email"
                        target="_blank"
                        rel="noreferrer noopener"
                    >
                        support@sparklingemail.com
                    </a>.
                </div>
                <br />
                <div className="col-12 col-md-6 mx-auto">
                    {dataset
                        ? <>
                            <div className="mb-3">
                                <label htmlFor="name" className="form-label fw-semibold m-0">Name:</label>
                                <div className="text-muted mb-1">Synced from your login provider.</div>
                                <input id="name" type="text" className="form-control" value={dataset?.displayName ?? ""} disabled readOnly />
                            </div>
                            <div className="mb-3">
                                <label htmlFor="email" className="form-label fw-semibold m-0">Email:</label>
                                <div className="text-muted mb-1">Your primary account email.</div>
                                <input id="email" type="email" className="form-control" value={dataset?.userEmail ?? ""} disabled readOnly />
                            </div>
                            <div className="mb-3">
                                <label htmlFor="createdOn" className="form-label fw-semibold m-0">Account Created On</label>
                                <div className="text-muted mb-1">The date you first joined Sparkling Email.</div>
                                <input id="createdOn" type="text" className="form-control" value={dataset?.createdOn ?? ""} disabled readOnly />
                            </div>
                            <div className="mb-3">
                                <label htmlFor="signInProvider" className="form-label fw-semibold m-0">Last Login:</label>
                                <div className="text-muted mb-1">Last time you signed in to your account.</div>
                                <input id="signInProvider" type="text" className="form-control" value={`${dataset?.updatedOn} via ${dataset?.signInProvider}`} disabled readOnly />
                            </div>
                        </>
                        : <ComLoading message="Loading your profile..." />}
                </div>
            </div>
        </>
    </>
};

export default AppProfile;